<template>
  <p class="mb-8 font-regular text-xl md:text-2xl" v-bind="$attrs">
    <slot />
  </p>
</template>
